import variablePlans from "./variablePlans.component";
import variablePlansUrls from "./variablePlans.urls";
import VariablePlansTransforms from "./variablePlans.transforms";

const variablePlansModule = angular
  .module("app.components.variablePlans", [])
  .component("variablePlansPage", variablePlans)
  .service("VariablePlansTransforms", VariablePlansTransforms)
  .config(variablePlansUrls);

export default variablePlansModule;



// WEBPACK FOOTER //
// ./src/pages/variablePlans/variablePlans.module.js